<template>
  <div class="home">
    <section class="hero">
      <div class="hero-content" data-aos="fade-up">
        <h1>LLyon Engenharia</h1>
        <p>Excelência em serviços de engenharia mecânica com qualidade e segurança</p>
        <router-link to="/contato" class="cta-button">Solicite um Orçamento</router-link>
      </div>
    </section>

    <section class="features">
      <div class="container">
        <h2 data-aos="fade-up">Por que escolher a LLyon?</h2>
        <div class="features-grid">
          <div class="feature-card" data-aos="fade-up" data-aos-delay="100">
            <i class="fas fa-certificate"></i>
            <h3>Experiência Comprovada</h3>
            <p>Vasta experiência na área de engenharia e segurança</p>
          </div>
          <div class="feature-card" data-aos="fade-up" data-aos-delay="200">
            <i class="fas fa-shield-alt"></i>
            <h3>Segurança Garantida</h3>
            <p>Compromisso com as normas técnicas e segurança</p>
          </div>
          <div class="feature-card" data-aos="fade-up" data-aos-delay="300">
            <i class="fas fa-handshake"></i>
            <h3>Atendimento Personalizado</h3>
            <p>Soluções sob medida para cada cliente</p>
          </div>
        </div>
      </div>
    </section>

    <section class="cta-section">
      <div class="container" data-aos="fade-up">
        <h2>Pronto para começar seu projeto?</h2>
        <p>Entre em contato conosco e descubra como podemos ajudar</p>
        <router-link to="/contato" class="cta-button">Fale Conosco</router-link>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style lang="scss" scoped>
.home {
  .hero {
    height: 100vh;
    background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('../assets/images/inicio.png');
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: white;
    padding: 0 1rem;

    .hero-content {
      max-width: 800px;

      h1 {
        font-size: 3.5rem;
        margin-bottom: 1rem;
      }

      p {
        font-size: 1.5rem;
        margin-bottom: 2rem;
      }
    }
  }

  .features {
    padding: 5rem 0;
    background-color: var(--light-bg);

    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 1rem;
    }

    h2 {
      text-align: center;
      margin-bottom: 3rem;
      color: var(--primary-color);
    }

    .features-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 2rem;
    }

    .feature-card {
      text-align: center;
      padding: 2rem;
      background: white;
      border-radius: 10px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      transition: transform 0.3s ease;

      &:hover {
        transform: translateY(-5px);
      }

      i {
        font-size: 2.5rem;
        color: var(--secondary-color);
        margin-bottom: 1rem;
      }

      h3 {
        margin-bottom: 1rem;
        color: var(--primary-color);
      }
    }
  }

  .cta-section {
    padding: 5rem 0;
    background-color: var(--primary-color);
    color: white;
    text-align: center;

    .container {
      max-width: 800px;
      margin: 0 auto;
      padding: 0 1rem;
    }

    h2 {
      margin-bottom: 1rem;
    }

    p {
      margin-bottom: 2rem;
    }
  }

  .cta-button {
    display: inline-block;
    padding: 1rem 2rem;
    background-color: var(--secondary-color);
    color: white;
    text-decoration: none;
    border-radius: 5px;
    transition: background-color 0.3s ease;

    &:hover {
      filter: brightness(90%);
    }
  }
}

@media (max-width: 768px) {
  .home {
    .hero {
      height: 100vh;
      background-attachment: scroll;
      padding-top: 4rem;

      .hero-content {
        h1 {
          font-size: 2.2rem;
          margin-bottom: 0.8rem;
        }

        p {
          font-size: 1.1rem;
          margin-bottom: 1.5rem;
          padding: 0 1rem;
        }

        .cta-button {
          padding: 0.8rem 1.5rem;
          font-size: 1rem;
        }
      }
    }

    .features {
      padding: 3rem 0;

      h2 {
        font-size: 1.8rem;
        margin-bottom: 2rem;
      }

      .features-grid {
        gap: 1.5rem;
      }

      .feature-card {
        padding: 1.5rem;

        i {
          font-size: 2rem;
        }

        h3 {
          font-size: 1.2rem;
        }

        p {
          font-size: 0.9rem;
        }
      }
    }

    .cta-section {
      padding: 3rem 0;

      h2 {
        font-size: 1.8rem;
      }

      p {
        font-size: 1rem;
        padding: 0 1rem;
      }
    }
  }

  @media (max-width: 480px) {
    .home {
      .hero {
        .hero-content {
          h1 {
            font-size: 2rem;
          }

          p {
            font-size: 1rem;
          }
        }
      }
    }
  }
}
</style>